import { BottomSheet } from './BottomSheet';
import { Trash2, FileText, Zap } from 'lucide-react';

export function LineBottomSheet({
  startName,
  endName,
  linkedtp,
  isEditable,
  isFiderActive,
  onClose,
  onDelete,
  onPassport,
  onShowFider,
  onHideFider
}) {
  return (
    <BottomSheet
      title={`${startName} - ${endName}`}
      onClose={onClose}
      open={true}
      isEditable={isEditable}
      onDelete={() => { onDelete(); onClose(); }}
    >
      {/* Подзаголовок */}
      <p style={{ fontSize: '13px', color: '#9ca3af', marginTop: -8, marginBottom: 16 }}>
        {linkedtp}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

        <button
          onClick={() => { onPassport(); /*onClose();*/ }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '14px',
            borderRadius: '12px',
            background: '#eff6ff',
            color: '#1d4ed8',
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <FileText size={16} />
          Паспорт
        </button>

        <button
          onClick={() => { 
            isFiderActive ? onHideFider() : onShowFider(); 
            onClose(); 
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '14px',
            borderRadius: '12px',
            border: 'none',
            background: isFiderActive ? '#f5f5f5' : '#eff6ff',
            color: isFiderActive ? '#374151' : '#1d4ed8',
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <Zap size={16} />
          {isFiderActive ? 'Скрыть схему фидера' : 'Показать схему фидера'}
        </button>
      </div>
    </BottomSheet>
  );
}